var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid gap-6 lg:grid-cols-2 lg:px-16 lg:pl:20"},[_c('ImpactText'),_c('HeroMap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }